export const createActionName = (reducerName, name) => `app/${reducerName}/${name}`

export const createReducer = (reducer, initialState) =>
    function (state = initialState, { type, payload }) {
        if (reducer[type]) {
            return reducer[type](state, payload)
        }
        return state
    }
